<h2 mat-dialog-title translate>dialog.session.title</h2>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-content>
  <p class="dialog__text--margin" translate>dialog.session.p1</p>
  <p translate>dialog.session.p2</p>
  <mat-progress-bar type="danger" [value]="progressCount" color="accent" animate="true" class="progress-striped active">
  </mat-progress-bar>
  <p>
    <strong translate>dialog.session.p3</strong>
    {{
      (countMinutes !== 0
        ? +countMinutes + ('dialog.session.minutes' | translate) + (countMinutes > 1 ? 's ' : ' ')
        : '') +
        countSeconds +
        ' ' +
        ('dialog.session.seconds' | translate)
    }}
  </p>
</mat-dialog-content>
<mat-divider class="dialog__divider--bottom"></mat-divider>
<mat-dialog-actions align="center">
  <button id="continueButtonSessionDialog" mat-flat-button color="accent" class="btnMobile" (click)="continue()">
    <span translate>dialog.session.button1</span>
  </button>
  <button id="logoutButtonSessionDialog" mat-flat-button color="primary" class="btnMobile" (click)="logout()">
    <span translate>dialog.session.button2</span>
  </button>
</mat-dialog-actions>
